import React from "react";
import {
  ChevronRight,
  Target,
  FlaskConical,
  Swords,
  Users,
  Package,
} from "lucide-react";

export default function OnboardingOverlay({ stats, onNext }) {
  const steps = [
    {
      id: 0,
      title: "Welcome to the Block",
      description:
        "The streets are cold, but the money is hot. Let's get your empire started.",
      button: "Show me the ropes",
      icon: <Target className="text-blue-500" />,
    },
    {
      id: 1,
      title: "Step 1: The First Job",
      description:
        "Every kingpin starts small. Go to SYNDICATE > CITY and commit your first crime to earn some starting capital.",
      target: { category: "SYNDICATE", tab: "CITY" },
      icon: <Swords className="text-red-500" />,
    },
    {
      id: 2,
      title: "Step 2: Recruit Muscle",
      description:
        "Protection is everything. Head to HOME > EMPIRE and scout your first 'Active Muscle' unit.",
      target: { category: "HOME", tab: "EMPIRE" },
      icon: <Users className="text-green-500" />,
    },
    {
      id: 3,
      title: "Step 3: Setup the Lab",
      description:
        "Now we produce. Go to SYNDICATE > OPERATIONS > COOKBOOK and unlock The Reggie formula.",
      target: { category: "SYNDICATE", tab: "OPERATIONS" },
      icon: <FlaskConical className="text-purple-500" />,
    },
    {
      id: 4,
      title: "Step 4: The First Batch",
      description:
        "In the COOKBOOK tab, use a turn to 'Cook Product' and stock your stash.",
      target: { category: "SYNDICATE", tab: "OPERATIONS" },
      icon: <FlaskConical className="text-green-400" />,
    },
    {
      id: 5,
      title: "Step 5: Move the Weight",
      description:
        "Product is useless sitting in a bando. Go to SYNDICATE > OPERATIONS > DROPS and sell your batch.",
      target: { category: "SYNDICATE", tab: "OPERATIONS" },
      icon: <Package className="text-blue-400" />,
    },
    {
      id: 6,
      title: "Step 6: Logistics Fleet",
      description:
        "To move weight automatically, you need runners. Go back to HOME > EMPIRE and scout your first Runner.",
      target: { category: "HOME", tab: "EMPIRE" },
      icon: <Users className="text-blue-500" />,
    },
    {
      id: 7,
      title: "Tutorial Complete",
      description:
        "You're ready to run this city. Keep expanding, join an Alliance, and take over districts!",
      button: "Finish",
      icon: <Target className="text-yellow-500" />,
    },
  ];

  const current = steps.find((s) => s.id === stats.tutorial_step);
  if (!current || stats.tutorial_step > 7) return null;

  return (
    <div className="fixed bottom-10 right-10 z-[10000] w-80 animate-in slide-in-from-right fade-in duration-500">
      <div className="bg-zinc-950 border-2 border-blue-600 p-6 shadow-[10px_10px_0px_0px_rgba(37,99,235,1)]">
        <div className="flex items-center gap-3 mb-3">
          {current.icon}
          <h3 className="text-sm font-black text-white uppercase italic">
            {current.title}
          </h3>
        </div>
        <p className="text-[11px] text-zinc-400 font-bold mb-4 leading-relaxed">
          {current.description}
        </p>
        {current.button && (
          <button
            onClick={onNext}
            className="w-full bg-blue-600 hover:bg-white text-black font-black py-2 text-[10px] uppercase italic transition-all flex items-center justify-center gap-2"
          >
            {current.button} <ChevronRight size={14} />
          </button>
        )}
      </div>
    </div>
  );
}
